import { appgamiAutomationAuthorizationUrl } from './azure-authorization-url.util';

interface OpenPermissionPageArgs {
  organizationName: string;
  organizationId: string;
}

export const openPermissionPage = (args: OpenPermissionPageArgs) => {
	const { organizationName, organizationId } = args;

	const tabHeight = 600;
	const tabWidth = 920;

	const top = ((window.screen.height / 2) - tabHeight / 2);
	const left = ((window.screen.width / 2) + tabWidth);

	window.open(appgamiAutomationAuthorizationUrl({ organizationName, organizationId }),'mozillaWindow',`height=${tabHeight},width=${tabWidth},left=${left},top=${top}`);
};
